import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeroSummitPage from './pages/SummitLandingpage.tsx';
import ServicesPage from './pages/ServicesPage.tsx';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HeroSummitPage />} />
        <Route path="/services" element={<ServicesPage />} />
      </Routes>
    </Router>
  );
}
